module.exports = __webpack_public_path__ + "static/media/diabetes_analysis.aca3cacc.png";